import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  record: null,
  printType: "FULL", // FULL | SHORT | THERMAL
};

const printSlice = createSlice({
  name: "print",
  initialState,
  reducers: {
    openPrint: (state, action) => {
      state.isOpen = true;
      state.record = action.payload;
      state.printType = "FULL";
    },
    closePrint: (state) => {
      state.isOpen = false;
      state.record = null;
    },
    setPrintType: (state, action) => {
      state.printType = action.payload;
    },
  },
});

export const { openPrint, closePrint, setPrintType } = printSlice.actions;
export default printSlice.reducer;
